module.exports = __webpack_public_path__ + "img/pro_08.bdd2841f.jpg";